export const domainCountryMap = {
  // local
  'hn.localhost': 'HN',
  'co.localhost': 'CO',
  'ni.localhost': 'NI',

  // dev
  'fresqra.dev.cglcloud.in': 'CO',
  'hnfresqra.dev.cglcloud.in': 'HN',
  'cofresqra.dev.cglcloud.in': 'CO',
  'nifresqra.dev.cglcloud.in': 'NI',

  // stage
  'fresqra.stage.cglcloud.in': 'CO',
  'hnfresqra.stage.cglcloud.in': 'HN',
  'cofresqra.stage.cglcloud.in': 'CO',
  'nifresqra.stage.cglcloud.in': 'NI',

  // prod
  'nifresqra.cglcloud.com': 'NI',
  'tanbuenoquesenota.cargill.com': 'NI',
  'fresqra.tanbuenoquesenota.com': 'NI',
  'fresqrani.tanbuenoquesenota.com': 'NI',
  'tanbuenoquesenota.cglcloud.com': 'NI',
  'hnfresqra.cglcloud.com': 'HN',
  'fresqra.hn.tanbuenoquesenota.com': 'HN',
  'fresqrahn.tanbuenoquesenota.com': 'HN',
  'hntanbuenoquesenota.cglcloud.com': 'HN',
  'cofresqra.cglcloud.com': 'CO',
  'fresqra.pollosbucanero.com': 'CO',
  'fresqraco.pollosbucanero.com': 'CO',
  'pollosbucanero.cargill.com': 'CO',
  'pollosbucanero.cglcloud.com': 'CO',
};
